var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 5.95L27.2436 22.75H31.4436V19.25L27.9436 14V3.5H29.6936V0H8.6936V3.5H10.4436V5.95Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 9.79996V14L6.9436 19.25V22.75H17.4436V35H20.9436V22.75H23.3936L10.4436 9.79996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6687 34.9999C32.3187 34.9999 31.9687 34.8249 31.7937 34.6499L0.468701 3.32491C-0.0562988 2.79991 -0.0562988 1.92491 0.468701 1.39991C0.993701 0.874915 1.8687 0.874915 2.3937 1.39991L33.7187 32.7249C34.2437 33.2499 34.2437 34.1249 33.7187 34.6499C33.3687 34.8249 33.0187 34.9999 32.6687 34.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinned);
export default __webpack_public_path__ + "static/media/unpinned.b0575dcdc1d786a65a1260dda51f7bb2.svg";
export { ForwardRef as ReactComponent };